

const MeasureEvent = (options, name ) => {
  const stage = process.env.REACT_APP_STAGE || 'local';
  const isPrd = (stage === 'main');
  try {
    setTimeout(() => {
      const scriptElm = document.createElement('script');

      const script = `
        (() => {
          if(typeof(s_gi) === 'undefined') return null;
          const s = s_gi(${isPrd} ? "rcrthakenentrynetprd" : "rcrthakenentrynetdev");
          const options = ${JSON.stringify(options)}
          const keys = Object.keys(options);
          for (let i=0; i<keys.length; i++){
            s[keys[i]] = options[keys[i]];
          }
          // console.log(s);
          s.tl(this,'o',"${name}");
        })();
      `;
      scriptElm.innerHTML = script;
      document.body.appendChild(scriptElm);
    },0);
  } catch(e) {
    // console.log({ e });
  }
};
export default MeasureEvent;